// import React, { useEffect, useState ,useRef} from 'react';
// import './callDuration.scss';

// const CallDuration = ({ participants }) => {
//     const [startTime, setStartTime] = useState(null);
//     const [elapsedTime, setElapsedTime] = useState(0);
//     const [isRunning, setIsRunning] = useState(false);
//     const timerUpdateRef = useRef(null);

//     const calculateTime = () => {
//         if (startTime) {
//             const now = new Date();
//             const difference = now - startTime;
//             setElapsedTime(Math.floor(difference / 1000)); // convert milliseconds to seconds
//         }
        
//     };

//     useEffect(() => {
//         if (isRunning) {
//             const interval = setInterval(() => {
//                 calculateTime();
//             }, 1000);
//             timerUpdateRef.current = interval;
//         } else {
//             clearInterval(timerUpdateRef.current);
//         }

//         return () => clearInterval(timerUpdateRef.current);
//     }, [isRunning, startTime]);

//     useEffect(() => {
//         setIsRunning(participants.length > 0);
//         if (participants.length > 0) {
//             const now = new Date();
//             setStartTime(now);
//         } 
//     }, [participants]);

//     useEffect(() => {
//         // Adjust the timer on visibility change
//         const handleVisibilityChange = () => {
//             if (document.visibilityState === "visible" && isRunning) {
//                 calculateTime();
//             }
//         };

//         document.addEventListener('visibilitychange', handleVisibilityChange);
//         return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
//     }, [isRunning]);

//     useEffect(() => {
//         // Store the total seconds to simplify.
//         localStorage.setItem("timeUsedInSeconds", elapsedTime);
//     }, [elapsedTime]);

  
  

//     const formatTime = (time) => {
//         const hours = Math.floor(time / 3600);
//         const minutes = Math.floor((time % 3600) / 60);
//         const seconds = time % 60;
//         return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
//     };

//     return (
//         <>
//             <div className='call-duration-custom-container'>
//                 {formatTime(elapsedTime)}
//             </div>
//         </>
//     );
// }

// export default React.memo(CallDuration);




import React, { useEffect, useState, useRef } from 'react';
import './callDuration.scss';

const CallDuration = ({ participants, joinCallRes }) => {
    const [startTime, setStartTime] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const timerUpdateRef = useRef(null);

    // Set start time based on joinCallRes
    useEffect(() => {
        if (joinCallRes) {
            const now = Date.now();
            const callStartTime = now - (joinCallRes.total_call_time_limit_in_sec * 1000 -  joinCallRes.remaining_time_in_sec * 1000); // Calculate start time
            console.log(callStartTime,"time");
            setStartTime(callStartTime);
        }
    }, [joinCallRes]);

    // Calculate elapsed time
    const calculateTime = () => {
        if (startTime) {
            const now = Date.now();
            const difference = now - startTime; // Time elapsed in milliseconds
            setElapsedTime(Math.floor(difference / 1000)); // Convert to seconds
        }
    };

    // Start/stop timer based on participants
    useEffect(() => {
        setIsRunning(participants.length > 0);
    }, [participants]);

    // Handle timer updates
    useEffect(() => {
        if (isRunning) {
            const interval = setInterval(() => {
                calculateTime();
            }, 1000);
            timerUpdateRef.current = interval;
        } else {
            clearInterval(timerUpdateRef.current);
        }

        return () => clearInterval(timerUpdateRef.current);
    }, [isRunning, startTime]);

    // Adjust timer on visibility change
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && isRunning) {
                calculateTime();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [isRunning]);

    // Store elapsed time in localStorage
    useEffect(() => {
        localStorage.setItem("timeUsedInSeconds", elapsedTime);
    }, [elapsedTime]);

    // Format time for display
    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };
    return (
        <>
            <div className='call-duration-custom-container'>
                {formatTime(elapsedTime)}
            </div>
        </>
    );
};

export default React.memo(CallDuration);
